import Guid from "@/types/Guid";

export default class BaseEntity {
  Id = Guid.Empty;
  Deleted = false;
}
